const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* SKINPET · un solo pack en el carrito (se pone aquí porque es el primer script que carga el tema, antes que UpCart).
   Los packs ("Compra 1 Llevas 2", "Compra 2 Llevas 3"...) son alternativas, no se suman. Al pulsar "Agregar al carrito"
   se quitan primero del carrito las líneas de ESTE mismo producto (cualquier pack, incluido un doble toque sobre el mismo)
   y después se deja pasar el clic normal (UpCart añade solo el pack elegido). No toca otros productos del carrito
   (p. ej. Protección de Envío). Se engancha en fase de captura al clic del botón principal de la ficha; la barra fija
   también pasa por ahí porque hace click() sobre ese botón. */
(function () {
  if (window.skpSinglePack) return;
  window.skpSinglePack = true;
  var busy = false;

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('product-form button[name="add"], product-form [type="submit"]') : null;
      if (!btn) return;

      // Segunda pasada (la lanzamos nosotros): se deja pasar tal cual.
      if (btn.dataset.skpGo === '1') {
        delete btn.dataset.skpGo;
        return;
      }

      var m = location.pathname.match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      var handle = decodeURIComponent(m[1]);

      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return; // toques repetidos
      busy = true;

      var go = function () {
        btn.dataset.skpGo = '1';
        btn.click();
        setTimeout(function () { busy = false; }, 1500);
      };

      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var updates = {};
          var n = 0;
          (cart.items || []).forEach(function (it) {
            if (it.handle === handle) { updates[it.key] = 0; n++; }
          });
          if (!n) return;
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates }),
          });
        })
        .catch(function () {})
        .then(go);
    },
    true
  );
})();
